import {FormKnowYouMobile} from "./FormKnowYouMobile";
import {FormCreditSimulatorMobile} from "./FormCreditSimulatorMobile";
import {FormKnowYou} from "./FormKnowYou";
import {FormKnowYouJuridica} from "./FormKnowYouJuridica";
import {FormCreditSimulator} from "./FormCreditSimulator";
import {useRequestContext} from '../../../hooks/useRequestContext';
import {Desktop, LandscapePhonesAndSmaller, LandscapeTablet, TabletAndMinis} from "../../../utils/breakpoints";
import "./request-info.scss";
import imagen from '../../../assets/images/familia.png';
import { renderTypeIdentification } from "../../../utils/utils";
import { useEffect, useState } from "react";

interface FinancialInformationContainerProps {
    typeIdentification?: string,
    identification?: string,
    costProduct?: string,
    nameProduct?: string,
    errors?: any,
    values?: any,
}

export function RequestInfoContainer(props: FinancialInformationContainerProps) {
    const {errors, values} = props;
    const {request, setRequest} = useRequestContext();
    const [isReady, setIsReady] = useState(false);

    let isJuridica = false;
    const datosPersonaString = sessionStorage.getItem("personaValidada");
       if (datosPersonaString) {
           const datosPersona = JSON.parse(datosPersonaString);
      
           const numTipoDoc = datosPersona.tipIdenVal;
            isJuridica = numTipoDoc === renderTypeIdentification("NIT");
        } 
        const KnowYouForm = isJuridica ? FormKnowYouJuridica : FormKnowYou;
        const KnowYouFormMobile = isJuridica ? FormKnowYouJuridica : FormKnowYou;

       //isPersonaJ =  numTipoDoc == renderTypeIdentification("NIT");
            
    return (
        <>
            <Desktop>
                <div className="flex-container-simulator">
                    <div className="flex-item-left-simulator">
                        <img src={imagen} className="d-none d-xl-block familia" alt={''}/>
                    </div>
                    <div className="flex-item-right-simulator">
                        <KnowYouForm errors={errors} values={values}/>
                        <FormCreditSimulator errors={errors} values={values}/>
                    </div>
                </div>
            </Desktop>
            <LandscapeTablet>
                <>
                    <KnowYouForm errors={errors} values={values}/>
                    <FormCreditSimulator errors={errors} values={values}/>
                </>
            </LandscapeTablet>
            <LandscapePhonesAndSmaller>
                <>
                    <KnowYouFormMobile errors={errors} values={values}/>
                    <FormCreditSimulatorMobile errors={errors} values={values}/>
                </>
            </LandscapePhonesAndSmaller>
        </>
    )
}